"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _useSsr = _interopRequireDefault(require("../use-ssr"));

var _collections = require("../utils/collections");

const createElement = id => {
  const el = document.createElement('div');
  el.setAttribute('id', id);
  return el;
};

const usePortal = (selectId = (0, _collections.getId)(), getContainer) => {
  const id = `nextui-${selectId}`;
  const {
    isBrowser
  } = (0, _useSsr.default)();
  const [elSnapshot, setElSnapshot] = (0, _react.useState)(isBrowser ? createElement(id) : null);
  (0, _react.useEffect)(() => {
    const customContainer = getContainer ? getContainer() : null;
    const parentElement = customContainer || document.body;
    const hasElement = parentElement.querySelector(`#${id}`);
    const el = hasElement || createElement(id);

    if (!hasElement) {
      parentElement.appendChild(el);
    }

    setElSnapshot(el);
  }, []);
  return elSnapshot;
};

var _default = usePortal;
exports.default = _default;
module.exports = exports.default;